var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.hintTransition}},[(_vm.isHintShown)?_c(_vm.hintComponent,{tag:"component",on:{"hintClose":_vm.closeHint}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }